export var StateEnumType;
(function (StateEnumType) {
    StateEnumType["FULFILLED"] = "FULFILLED";
    StateEnumType["REJECTED"] = "REJECTED";
    StateEnumType["PENDING"] = "PENDING";
    StateEnumType["PROGRESS"] = "PROGRESS";
})(StateEnumType || (StateEnumType = {}));
export const FULFILLED = 'FULFILLED';
export const REJECTED = 'REJECTED';
export const PENDING = 'PENDING';
export const PROGRESS = 'PROGRESS';
//# sourceMappingURL=states.js.map